<template>
<div class="mb-1 Posts">
  <div v-if="isCanAdd">
    <hr />
    <PostForm @submitPost="submitPost($event)"/>
  </div>
  <PostsList :posts="posts" />
</div>
</template>
<script>
  import PostsList from './PostsList';
  import PostForm from './PostForm';

  export default {
    components: {
      PostsList,
      PostForm
    },
    props: {
      posts: {
        type: Array,
        required: true
      },
      isCanAdd: {
        type: Boolean,
        default: true
      },
    },
    methods: {
      submitPost(post) {
        this.$emit('submitPost', post);
      }
    }
  }
</script>
<style>
</style>
